module.exports = __webpack_public_path__ + "img/total-1.0e1c4466.svg";